import React from "react";
import { Endpoints } from "../../helpers/Endpoints";
import { authenticationService } from "../../services/authentication.service";
import { Globals } from "../../helpers/globals";
import { TylerEnvelopeService } from "../../services/SubmissionService";
import { TableView } from "@mui/icons-material";

export default function Sidebar() {
    const currentUser = Globals.currentUserValue;
    const portal =
        Globals.portalValue !== null && Globals.portalValue !== undefined;

    console.debug({ portal: portal });

    const onTylerEFile = (url: string) => {
        console.log("Beging Efile " + url);
        TylerEnvelopeService.initiateNewSuit().then(
            (resp) => {
                console.log("RESPONSE " + JSON.stringify(resp));
                if (resp.successful === true && resp.data) {
                    window.location.href = url + "/" + resp.data.id;
                }
            },
            (error) => {
                console.log("RESPONSE ");
            }
        );
    };

    return (
        <div className="left-side-menu" style={{ zIndex: 100 }}>
            <div className="logo-box">
                <a href="index.html" className="logo logo-dark text-center">
                    <span className="logo-sm">
                        <img
                            src="../assets/images/logo-sm-dark.png"
                            alt=""
                            height="24"
                        />
                    </span>
                    <span className="logo-lg">
                        <img
                            src="../assets/images/logo-dark.png"
                            alt=""
                            height="20"
                        />
                    </span>
                </a>
                <a href="index.html" className="logo logo-light text-center">
                    <span className="logo-sm">
                        <img
                            src="../assets/images/logo-sm.png"
                            alt=""
                            height="24"
                        />
                    </span>
                    <span className="logo-lg">
                        <img
                            src="../assets/images/logo-light.png"
                            alt=""
                            height="20"
                        />
                    </span>
                </a>
            </div>

            <div className="h-100" data-simplebar>
                <div className="user-box text-center">
                    <div className="dropdown">
                        <a
                            href="#"
                            className="text-reset dropdown-toggle h5 mt-2 mb-1 d-block fw-medium"
                            data-bs-toggle="dropdown"
                        >
                            {currentUser?.name ?? ""}
                        </a>
                        <div className="dropdown-menu user-pro-dropdown">
                            <a
                                href="javascript:void(0);"
                                className="dropdown-item notify-item"
                            >
                                <i className="fe-user me-1"></i>
                                <span>My Account</span>
                            </a>
                            <a
                                href="javascript:void(0);"
                                className="dropdown-item notify-item"
                            >
                                <i className="fe-log-out me-1"></i>
                                <span>Logout</span>
                            </a>
                        </div>
                    </div>
                    <p className="text-reset">
                        {currentUser?.roleTitle ?? "Web User"}
                    </p>
                </div>
                {portal ? (
                    <div id="sidebar-menu">
                        <ul id="side-menu">
                            <li className="menu-title">e-Filing</li>
                            <li>
                                <a href="/dashboard">
                                    <i className="ri-layout-line"></i>
                                    <span> Dashboard </span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    onClick={() => {
                                        onTylerEFile("/tyler/new");
                                    }}
                                >
                                    <i className="ri-file-upload-line"></i>
                                    <span> New EFile </span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#sidebarFirms"
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    aria-controls="sidebarFirms"
                                >
                                    <i className="ri-building-4-line"></i>
                                    <span> Firms </span>
                                    <span className="menu-arrow"></span>
                                </a>
                                <div className="collapse" id="sidebarFirms">
                                    <ul className="nav-second-level">
                                        <li>
                                            <a href="/tyler/firms">
                                                <span>My Firm</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a
                                    href="#sidebarMyCases"
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    aria-controls="sidebarMyCases"
                                >
                                    <i className="ri-briefcase-4-line"></i>
                                    <span> My Cases </span>
                                    <span className="menu-arrow"></span>
                                </a>
                                <div className="collapse" id="sidebarMyCases">
                                    <ul className="nav-second-level">
                                        <li>
                                            <a href="/tyler/cases/case-search">
                                                Case Search
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                ) : (
                    <div id="sidebar-menu">
                        <ul id="side-menu">
                            <li className="menu-title">e-Filing</li>
                            {currentUser?.role &&
                                currentUser.role!.key! >= 100 && (
                                    <li>
                                        <a href="/dashboard">
                                            <i className="ri-layout-line"></i>
                                            <span> Dashboard </span>
                                        </a>
                                    </li>
                                )}
                            <li>
                                <a href="/uploads">
                                    <i className="ri-file-upload-line"></i>
                                    <span> Upload </span>
                                </a>
                            </li>
                            {currentUser?.role &&
                                currentUser.role!.key! >= 500 && (
                                    <li>
                                        <a
                                            href="#sidebarMatterManagment"
                                            data-bs-toggle="collapse"
                                            aria-expanded="false"
                                            aria-controls="sidebarMatterManagment"
                                        >
                                            <TableView />
                                            <span>eMatterMagic</span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                        <div
                                            className="collapse"
                                            id="sidebarMatterManagment"
                                        >
                                            <ul className="nav-second-level">
                                                <li>
                                                    <a href="/matter/management">
                                                        Active Matters
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/matter/create">
                                                        Create
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/matter/archived">
                                                        Archive
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/matter/import">
                                                        Import
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )}
                            {currentUser?.role &&
                                currentUser.role!.key! >= 100 && (
                                    <li>
                                        <a
                                            href="#sidebarFile"
                                            data-bs-toggle="collapse"
                                            aria-expanded="false"
                                            aria-controls="sidebarFile"
                                        >
                                            <i className="ri-article-line"></i>
                                            <span> Queue </span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                        <div
                                            className="collapse"
                                            id="sidebarFile"
                                        >
                                            <ul className="nav-second-level">
                                                <li>
                                                    <a href="/queue">All</a>
                                                </li>
                                                <li>
                                                    <a href="/queue/available">
                                                        Available
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/existing">
                                                        Exisiting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/new">
                                                        New Cases
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/service">
                                                        Service
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/dfs">DFS</a>
                                                </li>
                                                <li>
                                                    <a href="/queue/orders">
                                                        Orders
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/hold">
                                                        Hold
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/processing">
                                                        Processing
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/queue/preprocess">
                                                        Preprocess
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )}
                            <li>
                                <a
                                    href="#sidebarReporting"
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    aria-controls="sidebarReporting"
                                >
                                    <i className="ri-numbers-line"></i>
                                    <span> Reporting </span>
                                    <span className="menu-arrow"></span>
                                </a>
                                <div className="collapse" id="sidebarReporting">
                                    <ul className="nav-second-level">
                                        <li>
                                            <a href="/reporting/recent">
                                                Recent Filings
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/reporting/efiling">
                                                e-Filing History
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/reporting/status">
                                                Filing Status
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a href="/pages/mycases">
                                    {" "}
                                    <i className="ri-briefcase-4-line"></i>{" "}
                                    <span>My Cases</span>
                                </a>
                            </li>
                            {currentUser?.role &&
                                (currentUser.role!.key! >= 500 ||
                                    currentUser.role!.key! == 60) && (
                                    <>
                                        <li className="menu-title mt-2">
                                            Admin
                                        </li>
                                        {currentUser?.role &&
                                            currentUser.role!.key! >= 700 && (
                                                <li>
                                                    <a
                                                        href="#sidebarFirms"
                                                        data-bs-toggle="collapse"
                                                        aria-expanded="false"
                                                        aria-controls="sidebarFirms"
                                                    >
                                                        <i className="ri-building-4-line"></i>
                                                        <span> Firms </span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <div
                                                        className="collapse"
                                                        id="sidebarFirms"
                                                    >
                                                        <ul className="nav-second-level">
                                                            <li>
                                                                <a href="/admin/firms">
                                                                    All
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/firms/active">
                                                                    Active
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/firms/inactive">
                                                                    Inactive
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            )}
                                        {currentUser?.role &&
                                            (currentUser.role!.key! >= 700 ||
                                                currentUser.role!.key! ==
                                                    60) && (
                                                <li>
                                                    <a
                                                        href="#sidebarAttorneys"
                                                        data-bs-toggle="collapse"
                                                        aria-expanded="false"
                                                        aria-controls="sidebarAttorneys"
                                                    >
                                                        <i className="ri-scales-line"></i>
                                                        <span> Attorneys </span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <div
                                                        className="collapse"
                                                        id="sidebarAttorneys"
                                                    >
                                                        <ul className="nav-second-level">
                                                            <li>
                                                                <a href="/admin/attorneys">
                                                                    All
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/attorneys/active">
                                                                    Active
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/attorneys/inactive">
                                                                    Inactive
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            )}
                                        {currentUser?.role &&
                                            currentUser.role!.key! >= 700 && (
                                                <li>
                                                    <a
                                                        href="#sidebarTools"
                                                        data-bs-toggle="collapse"
                                                        aria-expanded="false"
                                                        aria-controls="sidebarTools"
                                                    >
                                                        <i className="ri-tools-line"></i>
                                                        <span> Tools </span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <div
                                                        className="collapse"
                                                        id="sidebarTools"
                                                    >
                                                        <ul className="nav-second-level">
                                                            <li>
                                                                <a href="/admin/split">
                                                                    Split
                                                                    Documents
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/jplocator">
                                                                    Justice of
                                                                    Peace
                                                                    Locator
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/queue-settings">
                                                                    Queue
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            )}
                                        {currentUser?.role &&
                                            currentUser.role!.key! >= 700 && (
                                                <li>
                                                    <a
                                                        href="#sidebarOrganizations"
                                                        data-bs-toggle="collapse"
                                                        aria-expanded="false"
                                                        aria-controls="sidebarOrganizations"
                                                    >
                                                        <i className="ri-building-line"></i>
                                                        <span>
                                                            {" "}
                                                            Organizations{" "}
                                                        </span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <div
                                                        className="collapse"
                                                        id="sidebarOrganizations"
                                                    >
                                                        <ul className="nav-second-level">
                                                            <li>
                                                                <a href="/admin/organizations">
                                                                    All
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/organizations/active">
                                                                    Active
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/admin/organizations/inactive">
                                                                    Inactive
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            )}
                                        {currentUser.role!.key! >= 500 && (
                                            <li>
                                                <a
                                                    href="#sidebarProcessServers"
                                                    data-bs-toggle="collapse"
                                                    aria-expanded="false"
                                                    aria-controls="sidebarProcessServers"
                                                >
                                                    <i className="ri-service-line"></i>
                                                    <span>
                                                        {" "}
                                                        Process Servers{" "}
                                                    </span>
                                                    <span className="menu-arrow"></span>
                                                </a>
                                                <div
                                                    className="collapse"
                                                    id="sidebarProcessServers"
                                                >
                                                    <ul className="nav-second-level">
                                                        <li>
                                                            <a href="/admin/processservers">
                                                                All
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/admin/processservers/active">
                                                                Active
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/admin/processservers/inactive">
                                                                Inactive
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/admin/processservers/services-pending">
                                                                Pending Services
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <a
                                                href="#sidebarUsers"
                                                data-bs-toggle="collapse"
                                                aria-expanded="false"
                                                aria-controls="sidebarUsers"
                                            >
                                                <i className="ri-group-line"></i>
                                                <span> Users </span>
                                                <span className="menu-arrow"></span>
                                            </a>
                                            <div
                                                className="collapse"
                                                id="sidebarUsers"
                                            >
                                                <ul className="nav-second-level">
                                                    <li>
                                                        <a href="/admin/users">
                                                            All
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/admin/users/active">
                                                            Active
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/admin/users/inactive">
                                                            Inactive
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        {currentUser.role &&
                                            currentUser.role!.key! >= 700 && (
                                                <>
                                                    <li>
                                                        <a
                                                            href="#sidebarRules"
                                                            data-bs-toggle="collapse"
                                                            aria-expanded="false"
                                                            aria-controls="sidebarRules"
                                                        >
                                                            <i className="ri-booklet-line"></i>
                                                            <span> Rules </span>
                                                            <span className="menu-arrow"></span>
                                                        </a>
                                                        <div
                                                            className="collapse"
                                                            id="sidebarRules"
                                                        >
                                                            <ul className="nav-second-level">
                                                                <li>
                                                                    <a href="/admin/rules/counties">
                                                                        Counties
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/divisions">
                                                                        Divisions
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/casetypes">
                                                                        Case
                                                                        Types
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/doctypes">
                                                                        Document
                                                                        Types
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/fees">
                                                                        Fees
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/coversheets">
                                                                        Coversheets
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/messages">
                                                                        Messages
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/servicedocs">
                                                                        Service
                                                                        Documents
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/rules/errordetails">
                                                                        Error
                                                                        Details
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    <li className="menu-title mt-2">
                                                        Jobs
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#sidebarAuth"
                                                            data-bs-toggle="collapse"
                                                            aria-expanded="false"
                                                            aria-controls="sidebarAuth"
                                                        >
                                                            <i className="ri-character-recognition-line"></i>
                                                            <span>
                                                                {" "}
                                                                Auto-File{" "}
                                                            </span>
                                                            <span className="menu-arrow"></span>
                                                        </a>
                                                        <div
                                                            className="collapse"
                                                            id="sidebarAuth"
                                                        >
                                                            <ul className="nav-second-level">
                                                                <li>
                                                                    <a href="auth-login.html">
                                                                        Status
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="auth-login-2.html">
                                                                        Execute
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/jobs/auto-file/analytics">
                                                                        Analytics
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>

                                                    <li>
                                                        <a
                                                            href="#sidebarExpages"
                                                            data-bs-toggle="collapse"
                                                            aria-expanded="false"
                                                            aria-controls="sidebarExpages"
                                                        >
                                                            <i className="ri-folder-transfer-line"></i>
                                                            <span>
                                                                {" "}
                                                                Case Export{" "}
                                                            </span>
                                                            <span className="menu-arrow"></span>
                                                        </a>
                                                        <div
                                                            className="collapse"
                                                            id="sidebarExpages"
                                                        >
                                                            <ul className="nav-second-level">
                                                                <li>
                                                                    <a href="/admin/case-export/status">
                                                                        Status
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="/admin/case-export/execute">
                                                                        Execute
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#sidebarLoggingPages"
                                                            data-bs-toggle="collapse"
                                                            aria-expanded="false"
                                                            aria-controls="sidebarLoggingPages"
                                                        >
                                                            <i className="ri-folder-transfer-line"></i>
                                                            <span>Logging</span>
                                                            <span className="menu-arrow"></span>
                                                        </a>
                                                        <div
                                                            className="collapse"
                                                            id="sidebarLoggingPages"
                                                        >
                                                            <ul className="nav-second-level">
                                                                <li>
                                                                    <a href="/jobs/logging">
                                                                        Available
                                                                        Jobs
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>

                                                    <li className="menu-title mt-2">
                                                        Data
                                                    </li>
                                                    <li>
                                                        <a href="widgets.html">
                                                            <i className="ri-database-line"></i>
                                                            <span>
                                                                {" "}
                                                                Counties{" "}
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="widgets.html">
                                                            <i className="ri-database-line"></i>
                                                            <span>
                                                                {" "}
                                                                Divisions{" "}
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/data/casetypes">
                                                            <i className="ri-database-line"></i>
                                                            <span>
                                                                {" "}
                                                                Case Types{" "}
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/data/tags">
                                                            <i className="ri-database-line"></i>
                                                            <span> Tags </span>
                                                        </a>
                                                    </li>
                                                </>
                                            )}
                                    </>
                                )}
                        </ul>
                    </div>
                )}
                <div className="clearfix"></div>
            </div>
        </div>
    );
}
